export const connectionStatusStrings = {
  recoveryStarted:
    'Webphone connection issue detected. Attempting to reconnect...',
  recoverySuccess: 'Webphone connection restored',
} as const;
